import { useEffect, useRef } from 'react';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2.ts';
export const MULTI_ITEM_CHECKOUT_TEST_NAME = 'multi-item-checkout';
export const MULTI_ITEM_CHECKOUT_TEST_VARIANT = 'variant';

export const isMultiItemCheckoutVariant = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }
    return getAbTestV2(MULTI_ITEM_CHECKOUT_TEST_NAME)?.variant === MULTI_ITEM_CHECKOUT_TEST_VARIANT;
};

export const useMultiItemCheckoutABTest = (): void => {
    const testEventFired = useRef(false);
    const variant = getAbTestV2(MULTI_ITEM_CHECKOUT_TEST_NAME)?.variant;
    useEffect(() => {
        if (testEventFired.current || !variant) {
            return;
        }
        trackAbTestV2Variant(MULTI_ITEM_CHECKOUT_TEST_NAME);
        testEventFired.current = true;
    }, [variant]);
};
